// [ai] rec: one recording (title, date, gist) with Play — through the host, so the shell's player carries it across pages.
import { useEffect, useState } from "react";
import { useAtlas } from "../../sdk/react";
import type { MediaState } from "../../sdk/types";
import { ErrorCard } from "../cards";
import { querySpec, useHostQuery, Wait, type WidgetProps } from "./hooks";
import type { Schema } from "../props";
export const REC_PROPS: Schema = { id: { type: "string", required: true }, t: { type: "number" }, e: { type: "number" } };
type Item = { id: string; title: string; date?: string; gist?: string; duration?: number };
const mins = (s?: number) => (s ? `${Math.round(s / 60)} min` : "");
export function Rec({ spec }: WidgetProps) {
  const p = spec.props as { id: string; t?: number; e?: number }; const host = useAtlas(); const q = useHostQuery<Item>(querySpec(spec, "recording", { id: p.id }));
  const [m, setM] = useState<MediaState>(() => host.media.state());
  useEffect(() => host.media.on("state", setM), [host]);
  if (q.error) return <ErrorCard text={q.error.message} />; if (q.data === undefined) return <Wait />;
  const it = q.data; const live = m.rec === it.id;
  return (
    <div className="at-cat at-cat-rec">
      <div className="at-cat-rec-t">{it.title}</div><div className="at-cat-sub">{[it.date, mins(it.duration)].filter(Boolean).join(" · ")}</div>
      {it.gist ? <p className="at-cat-gist">{it.gist}</p> : null}
      <div className="at-cat-actions">{live && m.playing ? <button type="button" className="at-btn" onClick={() => host.media.pause()}>Pause</button> : <button type="button" className="at-btn" onClick={() => void host.media.play({ rec: it.id, t: p.t, e: p.e })}>{live ? "Resume" : "Play"}</button>}{live ? <span className="at-cat-live">{m.playing ? "playing" : "paused"}</span> : null}</div>
    </div>
  );
}
